import * as React from "react";
import classnames from "classnames";
import { Heading, variantMap } from "@grandvisionhq/elements";
import { Text } from "@grandvisionhq/iris-ui";
import { parseHtml, domToReact } from "@grandvisionhq/lib-utils-html";
import { isElement, isDomNode, isChildNodeElement, isAlignment } from "./typeguards.js";
/* empty css                  */
import { colorHexMap } from "../../Util/Util/color-map.js";
const regHex = /#([a-f0-9]{3}){1,2}\b/i;
const regPresetBg = /black|grey|white/;
const variantReverseMap = variantMap ? Object.entries(variantMap).reduce((acc, [key, value]) => ({ ...acc, [value]: key }), {}) : {};
const getOptions = (textColor) => {
  const rowIndex = 0;
  return {
    replace: (domNode) => {
      if (isElement(domNode) && domNode.name in variantReverseMap) {
        let align = "left";
        if (domNode.attribs.style?.includes("text-align")) {
          const styles = domNode.attribs.style.split(";");
          const textAlign = styles.find((s) => s.includes("text-align"));
          const [_, value] = textAlign ? textAlign.split(":").map((s) => s.trim()) : [];
          align = value && isAlignment(value) ? value : "left";
        }
        const childElements = domNode.children.filter(isDomNode);
        return /* @__PURE__ */ React.createElement(
          Heading,
          {
            variant: variantReverseMap[domNode.name],
            align,
            color: textColor === "white" ? "alt" : void 0
          },
          domToReact(childElements)
        );
      } else if (isElement(domNode) && domNode.name === "p") {
        const childElements = domNode.children.filter(isDomNode);
        const styleString = domNode.attribs?.style || "";
        const styleObject = styleString.split(";").reduce((acc, style) => {
          const [key, value] = style.split(":").map((s) => s.trim());
          if (key && value) {
            const camelKey = key.replace(/-([a-z])/g, (_, g) => g.toUpperCase());
            acc[camelKey] = value;
          }
          return acc;
        }, {});
        return /* @__PURE__ */ React.createElement(
          Text,
          {
            spacings: ["mb-5"],
            style: styleObject,
            color: textColor === "white" ? "alt" : void 0
          },
          domToReact(childElements)
        );
      } else if (isElement(domNode) && domNode.name === "tr") {
        const childElements = Array.from(domNode.children).filter(isChildNodeElement);
        const rowWithHeaders = childElements.find((element) => element.name === "th");
        const isHeaderRow = rowWithHeaders !== void 0;
        domNode.children.forEach((child, columnIndex) => {
          if (isChildNodeElement(child)) {
            if (child.name === "th") {
              const previousElement = child.prev?.prev;
              if (child.attribs.rowspan && parseInt(child.attribs.rowspan) > 1) {
                child.attribs.scope = "rowgroup";
              } else if (previousElement && isChildNodeElement(previousElement) && previousElement.attribs.id) {
                child.attribs.headers = previousElement.attribs.headers || previousElement.attribs.id;
              }
              child.attribs.id = `${rowIndex}_${columnIndex}`;
            } else if (!isHeaderRow && child.name === "td") {
              child.attribs.headers = `${rowIndex}_${columnIndex}`;
            }
          }
        });
      }
      return domNode;
    }
  };
};
const RichTextArea = ({
  id,
  content,
  className,
  textColor = "black",
  backgroundColor = "transparent",
  fullWidth,
  isContained,
  "data-t": dataT
}) => {
  const classNames = classnames(
    "rich-text-area",
    `rich-text-area--text-${textColor}`,
    { "rich-text-area--full-width": fullWidth },
    { "rich-text-area--contained": isContained },
    className
  );
  const richTextAreaStyle = {
    backgroundColor: regHex.test(backgroundColor) ? backgroundColor : regPresetBg.test(backgroundColor) ? colorHexMap[backgroundColor] : "transparent"
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      id,
      className: classNames,
      style: richTextAreaStyle,
      ...dataT && { "data-t": dataT }
    },
    parseHtml(content, getOptions(textColor))
  );
};
export {
  RichTextArea,
  RichTextArea as default
};
//# sourceMappingURL=RichTextArea.js.map
